import {
  useProjectsWipSummaryQuery,
  useProjectsWipTableDataQuery,
} from "@src/__generated__/graphql";
import { onError } from "@src/utils/apollo";
import type { Store } from "../Store";

export const useFetchTableData = (store: Store) => {
  const { refetch: refetchSummary, loading: loadingSummary } =
    useProjectsWipSummaryQuery({
      notifyOnNetworkStatusChange: true,
      variables: { filters: store.queryParams.filters },
      onCompleted(data) {
        store.setSummary(data);
      },
      ...onError(),
    });

  store.refetchSummary = refetchSummary;

  const { loading, refetch } = useProjectsWipTableDataQuery({
    notifyOnNetworkStatusChange: true,
    variables: store.queryParams,
    onCompleted(data) {
      store.setTableData(data);
    },
    ...onError(),
  });

  store.refetchProjectsWip = refetch;

  return { loading, loadingSummary };
};
